/* eslint-disable react/no-unused-state */
import React from 'react';
import Button from 'components/ui-components/Button';
import axios from 'axios';

import { cefRed } from 'constants/variables';

import SiteSearchCategoryResults from './category_results';
import SiteSearchBrandResults from './brand_results';
import SiteSearchProductResults from './product_results';

class SiteSearch extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      queried: false,
      products: [],
      prices: [],
      pricingError: false,
      categories: [],
      brands: [],
      mobile: false,
      loading: false,
      error: false,
    };

    this.closeSearch = this.closeSearch.bind(this);
    this.triggerSearch = this.triggerSearch.bind(this);
    this.debounceInput = this.debounceInput.bind(this);
    this.fullSearch = this.fullSearch.bind(this);
    this.search = this.search.bind(this);
    this.getPrices = this.getPrices.bind(this);
    this.viewLink = this.viewLink.bind(this);
    this.validateMobileDevice = this.validateMobileDevice.bind(this);

    /* eslint-disable no-lonely-if  */
    this.handleSearch = this.debounceInput(e => {
      if (e.target.value === '') {
        this.closeSearch();
      } else {
        if (e.keyCode === 27) {
          this.closeSearch();
        } else if (e.keyCode === 13) {
          if (e.target.value.length > 0) {
            this.fullSearch(true, e.target.value.trim());
          }
        } else {
          this.setState({ query: e.target.value.trim() }, () => {
            this.search();
          });
        }
      }
    }, 500);
  }
  /* eslint-enable no-lonely-if  */

  componentDidMount() {
    const { mobile } = this.props;
    this.setState({ mobile }, () => {
      this.validateMobileDevice();
    });
  }

  getPrices() {
    const { signed_in: signedIn } = this.props;
    const { products: productsList } = this.state;

    this.setState({ loadingPrices: true });

    if (signedIn === true) {
      const products = productsList.map(p => p.id).join(',');
      axios
        .get('/product_price', {
          params: { products },
          responseType: 'json',
        })
        .then(response => {
          this.setState({ prices: response.data, loadingPrices: false });
        })
        .catch(error => {
          this.setState({ pricingError: true, loadingPrices: false });
        });
    } else {
      this.setState({ pricingError: true, prices: [], loadingPrices: false });
    }
  }

  search() {
    this.setState({ loading: true, prices: [], pricingError: false });
    if (!this.state.mobile) {
      axios
        .get('/catalogue/products/autocomplete', {
          params: { query: this.state.query },
        })
        .then(response => {
          const { categories, products, brands } = response.data;
          const filteredCategories = categories.filter(
            cat => cat.highlighted_name !== undefined,
          );
          this.setState(
            {
              products,
              categories: filteredCategories,
              brands,
              loading: false,
              error: false,
              queried: true,
            },
            () => {
              this.getPrices();
            },
          );
        })
        .catch(error => {
          this.setState({ error: true, loading: false });
        });
    }
  }

  /* eslint-disable class-methods-use-this */
  debounceInput(a, b, c) {
    let d;
    let e;
    let f;
    let g;

    return function () {
      function h() {
        (d = null), c || (e = a.apply(f, g));
      }
      f = this;

      g = arguments;
      return (
        clearTimeout(d),
        (d = setTimeout(h, b)),
        c && !d && (e = a.apply(f, g)),
        e
      );
    };
  }
  /* eslint-enable class-methods-use-this */

  closeSearch() {
    document.querySelector('.main-search').value = '';
    this.setState({
      products: [],
      queried: false,
      categories: [],
      brands: [],
      query: '',
      error: false,
    });
  }

  triggerSearch(e) {
    const { query } = this.state;

    this.setState(
      {
        query: e.target.value.trim(),
      },
      () => {
        if (query !== '') {
          this.search();
        }
      },
    );
  }

  /* eslint-disable class-methods-use-this */
  viewLink(address) {
    window.location.href = address;
  }
  /* eslint-enable class-methods-use-this  */

  fullSearch(force = false, input = '') {
    const { query } = this.state;

    if (force === true && input !== '') {
      window.location.href = `/catalogue/products/search?q=${encodeURIComponent(
        input,
      )}`;
    } else if (query !== '') {
      window.location.href = `/catalogue/products/search?q=${encodeURIComponent(
        query,
      )}`;
    }
  }

  validateMobileDevice() {
    const excludedDevices = [[600, 960]];
    const deviceDimensions = [window.screen.width, window.screen.height];
    if (
      JSON.stringify(excludedDevices).indexOf(
        JSON.stringify(deviceDimensions),
      ) !== -1
    ) {
      this.setState({ mobile: true });
    }
  }

  render() {
    const {
      customer_services_email: customerServicesEmail,
      b2b_phone_number: b2bPhoneNumber,
      vat_exclusive: vatExclusive,
      assets,
      cro,
    } = this.props;

    const {
      brands,
      categories,
      loadingPrices,
      mobile,
      prices,
      pricingError,
      products,
      query,
      queried,
    } = this.state;

    const results =
      query !== '' && queried === true && mobile !== true ? (
        <div className="search-results">
          <div className="v2-container results-container">
            <div className="fl">
              <div className="v2-span3 brand-category-results">
                <SiteSearchCategoryResults
                  categories={categories}
                  viewLink={this.viewLink}
                  query={query}
                  brandCount={brands.length}
                />
                <SiteSearchBrandResults
                  brands={brands}
                  viewLink={this.viewLink}
                  query={query}
                  categoryCount={categories.length}
                />
              </div>
              <SiteSearchProductResults
                customerServicesEmail={customerServicesEmail}
                products={products}
                prices={prices}
                pricing_error={pricingError}
                query={query}
                viewLink={this.viewLink}
                fullSearch={this.fullSearch}
                b2bPhoneNumber={b2bPhoneNumber}
                assets={assets}
                vat_exclusive={vatExclusive}
                loadingPrices={loadingPrices}
              />
            </div>
          </div>
        </div>
      ) : (
        ''
      );
    return (
      <div
        role="presentation"
        className={`main-site-search ${queried === true ? ' active' : ''}`}
        onClick={e =>
          e.target.className === 'main-site-search active'
            ? this.closeSearch()
            : null
        }>
        <div
          className={`search-input-wrapper ${
            queried === true ? ' v2-container active' : ''
          }`}>
          <Button
            type="button"
            label="Close"
            className="close-search"
            handleClick={() => {
              this.closeSearch();
            }}>
            Close <img src={assets.close} alt="" height={18} width={18} />
          </Button>

          <div className="inputs">
            <input
              type="text"
              onFocus={e => {
                e.persist();
                this.triggerSearch(e);
              }}
              onKeyDown={e => {
                e.persist();
                this.handleSearch(e);
              }}
              onChange={e => {
                e.persist();
                this.handleSearch(e);
              }}
              onPaste={e => {
                e.persist();
                this.handleSearch(e);
              }}
              onClick={e => e.stopPropagation()}
              spellCheck="false"
              className={`main-search${cro ? ' search-cro__input' : ''}`}
              aria-label="search"
              placeholder="Search by keyword or part number"
            />
            <Button
              type="button"
              bgColour={cefRed}
              label="Search"
              className={`${cro ? 'search-cro__button' : ''}`}
              handleClick={e => {
                this.fullSearch();
                e.stopPropagation();
              }}>
              <img alt="" src={assets.search_white} height={17} width={18} />
            </Button>
          </div>
          {results}
        </div>
      </div>
    );
  }
}

export default SiteSearch;
